import React from 'react'
import { Switch } from 'react-router-dom'

import { PermissionRoute } from '../../common/components/routes'
import { APP_ROUTES, PERMISSIONS } from '../../common/constants'

import { LocationTypeCategoryDetailsPage } from './pages'

const LocationTypeCategoriesRouter = () => (
  <Switch>
    <PermissionRoute
      exact
      path={APP_ROUTES.LOCATION_TYPE_CATEGORIES_DETAILS.link}
      permissions={[PERMISSIONS.METADATA_TREE.GET]}
      component={LocationTypeCategoryDetailsPage}
    />
  </Switch>
)

export default LocationTypeCategoriesRouter
